import { render, staticRenderFns } from "./CodeValidator.vue?vue&type=template&id=31602ac1&scoped=true"
import script from "./CodeValidator.vue?vue&type=script&lang=js"
export * from "./CodeValidator.vue?vue&type=script&lang=js"
import style0 from "./CodeValidator.vue?vue&type=style&index=0&id=31602ac1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31602ac1",
  null
  
)

export default component.exports